import { Injectable } from '@angular/core';
import { fromEvent, map, share } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResizeService {
  public readonly innerWidth$ = fromEvent(window, 'resize').pipe(
    map(() => window.innerWidth),
    share(),
  );

  public readonly isMobile$ = this.innerWidth$.pipe(
    map((width) => width <= 576),
  );
}
